/**
 * ⚠️ Use http://www.color-blindness.com/color-name-hue/ to find meaningful
 * color names. In case of collision with an existing color in this file, feel
 * free to find a meaningful name by yourself, by inspiring you from the
 * existing.
 * In each hue (reds, oranges…), colors are sorted by decreasing brightness (// x%)
 */

export enum Color {
  // Reds
  Razzmatazz = "#F06", // 100%
  Ruby = "#ED1054", // 92%
  Cranberry = "#E04684", // 87%
  Valencia = "#D9534F", // 85%
  Cardinal = "#C91D42", // 78%

  // Oranges
  Sunglow = "#FFCA2A", // 100%
  Orange = "#FBAD07", // 98%
  DarkTangerine = "#F79919", // 96%

  // Yellows
  Casablanca = "#F0AD4E", // 94%

  // Greens
  Downy = "#67CAD4", // 83%
  Bermuda = "#7CCBC4", // 79%
  LightSeaGreen = "#28BBBB", // 73%
  PersianGreen = "#00AE9E", // 68%
  MountainMeadow = "#1FAA7A", // 66%
  Java = "#25879E", // 61%

  // Blues
  Solitude = "#F1F2F6", // 96%
  Solitude2 = "#E3E6ED", // 92%
  LinkWater = "#D6DBE4", // 89%
  LinkWater2 = "#BBC3D2", // 82%
  SummerSky = "#27B3D0", // 81%
  Heather = "#B9C0CB", // 79%
  PacificBlue = "#0887C9", // 78%
  RockBlue = "#939FB7", // 71%
  ShipCove = "#8593AE", // 68%
  Manatee = "#8D97A9", // 66%
  EastBay = "#545E74", // 45%
  Fiord = "#4B5261", // 38%
  SanJuan = "#485163", // 38%
  BlackRock = "#303642", // 25%
  BlackPearl = "#202631", // 19%

  // Violets
  Cerise = "#E2375C", // 88%
  Fuchsia = "#BE45B0", // 66%
  MulledWine = "#504A5F", // 37%
  Martinique = "#3D384C", // 29%
  Haiti = "#2B2833", // 20%

  // Browns
  Bisque = "#FFEBC1", // 100%

  // Blacks
  LightBlack = "#111", // 6%
  Black = "#000", // 0%

  // Transparent blacks
  Black04 = "rgba(0, 0, 0, 0.04)",
  Black06 = "rgba(0, 0, 0, 0.06)",
  Black12 = "rgba(0, 0, 0, 0.12)",
  Black16 = "rgba(0, 0, 0, 0.16)",
  Black26 = "rgba(0, 0, 0, 0.26)",
  Black38 = "rgba(0, 0, 0, 0.38)",
  Black54 = "rgba(0, 0, 0, 0.54)",
  Black65 = "rgba(0, 0, 0, 0.65)",
  Black87 = "rgba(0, 0, 0, 0.87)",

  // Greys
  VeryLightGrey = "#CCC", // 80%
  SilverD = "#BDBDBD", // 74%
  DarkGrey = "#AAA", // 66%
  Nobel = "#999", // 60%
  SlateGrey = "#6C7995", // 58%
  DimGrey = "#666", // 40%
  Arsenic = "#353A44", // 26%
  Charcoal = "#444", // 26%
  NightRider = "#333", // 20%
  Cinder = "#242831", // 19%

  // Whites
  White = "#FFF", // 100%
  WhiteSmoke = "#F6F6F6", // 96%
  LightGrey = "#F5F5F5", // 96%
  GreySmoke = "#EEE", // 93%
  LightSmoke = "#E5E5E5", // 89%
  Gainsboro = "#DDD", // 86%

  // Transparent whites
  White12 = "rgba(255, 255, 255, 0.12)",
  White24 = "rgba(255, 255, 255, 0.24)",
  White30 = "rgba(255, 255, 255, 0.30)",
  White50 = "rgba(255, 255, 255, 0.50)",
  White70 = "rgba(255, 255, 255, 0.70)",

  // Others
  Transparent = "transparent",
}

export const getColorFromFirstLetter = (label: string = "") => {
  const letterValue = label[0].toLowerCase().charCodeAt(0);
  if (letterValue < 102) return Color.Orange; // A-E
  if (letterValue < 107) return Color.PacificBlue; // F-J
  if (letterValue < 112) return Color.LightSeaGreen; // K-O
  if (letterValue < 117) return Color.Cerise; // P-T
  return Color.DimGrey; // U-Z
};
